<template>
  <div>
    <base-confirmation-modal
      :id="confirmationData.id"
      :title="confirmationData.title"
      :on-submit="confirmationData.onSubmit"
      @done="fetchVendors"
    />
    <vendor-locations-viewer :locations="currentVendorLocations" />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="vendorsLoading"
    >
      <b-card>
        <b-button
          v-if="$can('write', 'vendors')"
          variant="primary"
          class="mb-2"
          @click="$router.push('/vouchers/vendors/new')"
        >
          <span
            class="text-nowrap"
          >Add Vendor</span>
        </b-button>
        <b-table
          responsive
          :fields="columns"
          :items="vendors"
          primary-key="id"
          show-empty
          empty-text="No matching vendors found"
        >
          <template #cell(additionalData)="data">
            <b-button
              class="btn-icon rounded-circle ml-1"
              variant="flat-primary"
              @click="displayVendorLocations(data.item.additionalData.locations)"
            >
              <feather-icon
                icon="MapIcon"
                size="16"
              />

            </b-button>
          </template>
          <template #cell(active)="data">
            {{ data.item.active ? 'Yes' : 'No' }}
          </template>
          <template #cell(createdAt)="data">
            {{ data.item.createdAt | formatDate }}
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="data.item.active"
                @click="handleChangeStatus('deactivate',data.item)"
              >
                <feather-icon icon="CheckIcon" />
                <span class="align-middle ml-50">Deactivate</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-else
                @click="handleChangeStatus('activate',data.item)"
              >
                <feather-icon icon="XIcon" />
                <span class="align-middle ml-50">Activate</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'
import useVendorList from '../hooks/useVendorsList'
import BaseConfirmationModal from '@/UI/BaseConfirmationModal.vue'
import VendorLocationsViewer from '../comonents/VendorLocationsViewer.vue'

export default {
  components: {
    BButton,
    BCard,
    BTable,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BaseConfirmationModal,
    VendorLocationsViewer,
  },
  setup(_, ctx) {
    useRegisterStoreModule('vendors', store)

    return {
      ...useVendorList(ctx),
    }
  },
}
</script>

<style>

</style>
